import {academicHomepages, getWxSignature, getUserInfo, seePersonalData, getMoreDocs, saveAcademicHomepages, likes} from '@/api/index'
import wx from 'weixin-js-sdk'

export default {
  data () {
    return {
      notPublicSkeleton: true,
      headSkeleton: true,
      modulesSkeleton: true
    }
  },
  computed: {
    userId () {
      return parseInt(this.$route.params.id)
    },
    sideToolsVisible () {
      return this.data && this.data.modules &&
        !this.editing && !this.isMobile &&
        (!this.$store.state.config.fixedToolNav || !this.$store.state.config.fixedToolQrcode)
    }
  },
  watch: {
    is_first_edit (newValue, oldValue) {
      if (parseInt(newValue) === 1) {
        if (!this.isMobile) {
          this.editing = true
        }
      } else {
        this.editing = false
      }
    },
    userId () {
      this.seePersonalData()
      this.academicHomepages()
    }
  },
  methods: {
    getUserInfo () {
      var state = this.$route.query.state
      var code = this.$route.query.code
      if (state && code) {
        getUserInfo({code, state}).then((res) => {
          localStorage.setItem('scholar_wechat_info', JSON.stringify(res.data.wechat_info))
          let id = this.userId
          if (res.data.user_info === null) {
            this.$router.push({name: 'BindMobile', params: {id: id}})
          } else if (Number(res.data.user_info.mobile_checked) === 0) {
            this.$router.push({name: 'BindMobile', params: {id: id}})
          } else {
            window.location.href = `${window.location.origin}/${this.userId}`
            // 后端完成登陆状态
          }
        })
      }
    },
    /**
     * 保存数据 saveAcademicHomepages, 所有保存调用这个方法
     */
    saveAcademicHomepages (callback, errorCallback) {
      // 用户全局编辑状态下编辑个人资料时自动保存
      // 组装发送接口需要的数据
      let data = {}
      let profile = {}
      let modules = []
      let coverImage = {}
      this.$set(data, 'open_access', this.$store.state.config.openAccess)
      this.$set(data, 'color', this.$store.state.config.themeColor)
      this.$set(data, 'socialites', this.socialites)
      this.$set(data, 'email_hide', this.email_hide)
      // proifle 数据组装
      this.$set(profile, 'zh_name', this.profile.zh_name)
      this.$set(profile, 'avatar', this.profile.avatar)
      // title，degree 数据若不是数字则把它转成数字，若文字和相对应列表无对应关系则为空
      let title = this.profile.title
      if (isNaN(parseInt(title))) {
        let index = this.profile.titles_select.findIndex(n => n.value === title)
        title = index === -1 ? null : this.profile.titles_select[index].name
      }
      this.$set(profile, 'title', title)
      let degree = this.profile.degree
      if (isNaN(parseInt(degree))) {
        let index = this.profile.degree_select.findIndex(n => n.value === degree)
        degree = index === -1 ? null : this.profile.degree_select[index].name
      }
      this.$set(profile, 'degree', degree)
      // tutor 根据 value 匹配到相应 key
      for (let key in this.profile.tutor_select) {
        if (this.profile.tutor === this.profile.tutor_select[key]) {
          this.$set(profile, 'tutor', key)
        }
      }
      this.$set(profile, 'school_id', this.profile.school_id)
      this.$set(profile, 'school_name', this.profile.school_name)
      this.$set(profile, 'user_tags', this.profile.user_tags)
      // modules 数据组装
      this.data.modules.forEach((item, index) => {
        if (item.name === 'intro' || item.name === 'education' || item.name === 'career') {
          modules.push(item)
        } else {
          let object = {}
          object.is_show = item.is_show
          object.name = item.name
          object.sort_type = item.sort_type
          object.data = []
          item.data.length && item.data.forEach((item, index) => {
            let obj = {}
            obj.id = item.id
            obj.display_status = item.display_status
            object.data.push(obj)
          })
          modules.push(object)
        }
      })
      if (!this.isMobile) {
        if (this.$refs.colorPaletteref.isSelect.isNotCover) {
          this.select_cover_type = 0
        } else if (this.$refs.colorPaletteref.isSelect.isRandomCover) {
          this.select_cover_type = 1
        } else {
          this.select_cover_type = 2
        }
        this.randomImgUrl = this.$refs.colorPaletteref.RandombackdropUrl
        this.uploadImgUrl = this.$refs.colorPaletteref.backdropUrl
      }

      if (this.select_cover_type === 0 || this.select_cover_type === 1 || this.select_cover_type === 2) {
        this.$set(coverImage, 'cover_type', this.select_cover_type)
        if (this.select_cover_type === 2) {
          this.$set(coverImage, 'current_cover', this.uploadImgUrl)
        } else if (this.select_cover_type === 1) {
          let randomImgUrl = this.randomImgUrl.replace(/_s_/, '_')
          this.$set(coverImage, 'current_cover', randomImgUrl)
        }
        this.$set(coverImage, 'custom_cover', this.uploadImgUrl)
        this.$set(coverImage, 'random_cover', this.randomImgUrl)
        let moblileCover = this.randomImgUrl.replace(/_s_/, '_h5_')
        this.$set(coverImage, 'h5_cover', moblileCover)
        this.$set(data, 'cover_image', coverImage)
      } else {
        this.$set(data, 'cover_image', this.coverImageObj)
      }
      // 侧边导航和二维码
      this.$set(data, 'fixedtool_nav', this.$store.state.config.fixedToolNav)
      this.$set(data, 'fixedtool_qrcode', this.$store.state.config.fixedToolQrcode)
      this.$set(data, 'profile', profile)
      this.$set(data, 'modules', modules)
      this.$set(this.loginUser, 'login_user_avatar', this.profile.avatar)
      this.$set(this.loginUser, 'login_user_name', this.profile.zh_name)
      console.log(data)
      saveAcademicHomepages(this.$route.params.id, data).then((data) => {
        let {code} = data
        if (code === 1) {
          typeof callback === 'function' && (callback())
          this.dataClone.modules = this.data.modules
        } else {
          typeof errorCallback === 'function' && (errorCallback())
        }
      }).catch(() => {
        typeof errorCallback === 'function' && (errorCallback())
      })
    },
    /********
     * 获取主页数据信息
     */
    academicHomepages () {
      academicHomepages(this.userId).then((res) => {
        let {data} = res
        if (!data.profile) {
          this.$router.push({name: 'notfound'})
        } else {
          data.color && (this.$store.commit('config/changeThemeColor', data.color))
          this.$store.commit('config/changeOpenAccess', String(data.open_access))
          this.$store.commit('config/changeFixedToolNav', Number(data.fixedtool_nav))
          this.$store.commit('config/changeFixedToolQrcode', Number(data.fixedtool_qrcode))
          this.changeThemeColor(this.$store.state.config.themeColor)
          this.data = data
          this.dataClone = JSON.parse(JSON.stringify(data))
          this.visiteCount = parseInt(data.visit_pv)
          this.open = parseInt(data.status) > 0
          this.likeCount = parseInt(data.likes_count) > 0 ? parseInt(data.likes_count) : null
          this.email_hide = data.email_hide
          this.loginUser = data.login_user
          this.open = parseInt(data.status) > 0
          data.socialites && (this.socialites = JSON.parse(data.socialites))
          this.is_first_edit = data.is_first_edit
          this.profile = data.profile
          if (!this.profile) {
            this.wxShare(data.profile)
          }
          if (this.loginUser && this.loginUser.is_self === 1) {
            // this.dealModules()
          }
          if (data.cover_image) {
            if (data.cover_image.cover_type === 2) {
              this.backgroundUrl = data.cover_image.custom_cover
              this.backgroundUrlMobile = data.cover_image.custom_cover
            } else if (data.cover_image.cover_type === 1) {
              this.backgroundUrlMobile = data.cover_image.h5_cover
              this.backgroundUrl = data.cover_image.current_cover
            } else {
              this.backgroundUrl = null
            }
            this.coverImageObj = data.cover_image
            this.backgroundUrlRondo = data.cover_image.random_cover
            this.customCoverUrl = data.cover_image.custom_cover
            this.coverType = data.cover_image.cover_type
          }
          this.$nextTick(() => {
            // 主页模块骨骼屏和页面显示之间会在元素绘制之间的时间差
            !this.open && (this.notPublicSkeleton = false)
            this.open && (this.headSkeleton = false)
            this.open && (this.modulesSkeleton = false)
          })
        }
      }).catch(() => {})
    },
    moreItem (index, callback) {
      let item = this.data.modules[index]
      getMoreDocs(this.userId, {'sort_type': item.sort_type || 'time:asc', 'docs_type': item.name}).then(res => {
        let {code, data} = res
        let hasMore = false
        if (code === 1) {
          this.data.modules[index].data = data
          this.dataClone.modules[index].data = JSON.parse(JSON.stringify(data))
          hasMore = data.length > 10
        }
        typeof callback === 'function' && (callback(hasMore))
      })
    },
    wxShare (profile) {
      let share = (ob, wxName, desc, url, wxIcon) => {
        // 通过config接口注入权限验证配置
        wx.config(ob)
        wx.ready(function () {
          // config信息验证成功后会执行ready方法
          wx.onMenuShareAppMessage({ // 分享给朋友  ,在config里面填写需要使用的JS接口列表，然后这个方法才可以用
            title: `${wxName}的学术主页`,
            desc: desc,
            link: url, // 分享链接
            imgUrl: wxIcon, // 分享图标
            type: '', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: function () {
            // 用户确认分享后执行的回调函数
            },
            cancel: function () {
            // 用户取消分享后执行的回调函数
            }
          })
          wx.onMenuShareTimeline({ // 分享朋友圈
            title: `${wxName}的学术主页`,
            link: url,
            imgUrl: wxIcon, // 分享图标
            success: function () {
            // 用户确认分享后执行的回调函数
            },
            cancel: function () {
            // 用户取消分享后执行的回调函数
            }
          })
        })
        wx.error(function (res) {
          console.log(res)
        })
      }
      // 态自定义学术主页微信分享内容
      if (this.isMobile) {
        let url = window.location.href
        getWxSignature({url: url}).then((res) => {
          let {code, data} = res
          if (code === 1) {
            if (this.open) {
              let ob = {
                debug: false,
                appId: data.appId,
                timestamp: data.timestamp,
                nonceStr: data.nonceStr,
                signature: data.signature,
                jsApiList: data.jsApiList
              }
              let tutor = profile.tutor
              tutor = tutor === '硕导' ? '硕士生导师' : (tutor === '博导' ? '博士生导师' : '')
              let title = profile.title === '其他' ? '' : profile.title
              share(ob, profile.zh_name, `${profile.school_name} ${title} ${tutor}`, url, profile.avatar)
            } else {
              // 通过config接口注入权限验证配置
              let ob = {
                debug: data.debug,
                appId: data.appId,
                timestamp: data.timestamp,
                nonceStr: data.nonceStr,
                signature: data.signature,
                jsApiList: data.jsApiList
              }
              share(ob, '学术主页计划', '展示学术成果 助力学者社交', `${window.location.origin}/homepage_m`, 'https://okay-pic.oss-cn-hangzhou.aliyuncs.com/acagrid/static/images/default/logo.jpg')
            }
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    seePersonalData () {
      seePersonalData(this.userId).then(res => {
        let {data} = res
        if (!data.profile) {
          this.$router.push({name: 'notfound'})
        } else {
          if (this.profile) {
            this.profile = data.profile
            this.wxShare(data.profile)
            this.$nextTick(() => {
              this.open && (this.headSkeleton = false)
            })
          }
        }
      })
    },
    editMoreItem (index) {
      if (this.data.modules) {
        // 获取更多
        let modules = index ? [this.data.modules[index]] : this.data.modules
        this.$nextTick(() => {
          for (let i = 0; i < modules.length; i++) {
            let tag = this.$refs[modules[i].name]
            if (tag) {
              try {
                tag.getMoreItem()
              } catch (e) {
                try {
                  tag[0].getMoreItem()
                } catch (e) {
                }
              }
            }
          }
        })
      }
    },
    /****
     * 点赞
     */
    likeAction (scroll) {
      if (this.loginUser === null) {
        if (this.isMobile) {
          this.authorize()
        } else {
          this.pcLoginDialogVisible = true
        }
        // 授权
      } else {
        likes(this.$route.params.id).then((res) => {
          this.likeCount = this.likeCount ? this.likeCount + 1 : 1
          if (scroll) {
            this.toLikeSection()
          }
          this.$set(this.loginUser, 'liked', 1)
          if (res.code === 1) {
            // 如果模块可见
            if (this.open) {
              this.data.likes = [res.data, ...this.data.likes]
            }
          } else {
            this.$message.error(res.message)
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Index/Index/apiMixins.js